import React from "react";
import {
  formatDuration,
  asSeconds,
} from "@highnote/server/src/core/shared-util";
import { GlobalAudioCurrentTime } from "App/components/GlobalAudioPlayer/GlobalAudioPlayer";

interface CommentTimestampProps {
  freezeTimestampWhileTyping: number | null;
}

export const CommentTimestamp = ({
  freezeTimestampWhileTyping,
}: CommentTimestampProps) => {
  if (freezeTimestampWhileTyping) {
    return (
      <span
        aria-label={`Comment will be added at ${formatDuration(
          asSeconds(freezeTimestampWhileTyping),
        )}`}
        role="status"
        aria-live="polite"
      >
        {formatDuration(asSeconds(freezeTimestampWhileTyping))}
      </span>
    );
  }

  return (
    <span
      aria-label="Current audio playback time"
      role="status"
      aria-live="polite"
    >
      <GlobalAudioCurrentTime />
    </span>
  );
};

CommentTimestamp.displayName = "CommentTimestamp";
